import { bootstrapApplication } from '@angular/platform-browser';
import { buildAppConfig } from './app/app.config';
import { App } from './app/app';
import { loadRuntimeConfig } from './app/core/config/runtime-config';

// main.ts
function applyInitialTheme() {
  const ls = localStorage.getItem('theme');
  // Default = light
  const isDark = ls === 'dark';
  document.documentElement.classList.toggle('dark', isDark);
}


applyInitialTheme();

// The API host and Keycloak client come from /config.json, so the app config
// is built only after that has been read.
loadRuntimeConfig()
  .then(() => bootstrapApplication(App, buildAppConfig()))
  .catch((err) => console.error(err));
